if (typeof window.RingmakerLogger === 'undefined') {
window.RingmakerLogger = class RingmakerLogger {
  constructor(customizer) {
    this.customizer = customizer;
    this.sessionId = this.generateSessionId();
    this.sessionStartTime = Date.now();
    this.converted = false;
    this.maxStepReached = 1;
    // Add to Cart outcome (2026-09-29, CUSTOM_THEME §10U A): `converted` stays "tapped Add to Cart";
    // `added_to_cart` is true only after Shopify confirmed the add.
    this.addedToCart = false;
    this.atcAttempts = 0;
    this.atcResult = null;
    this.logEndpoint = '/apps/ringmaker-logs';
    
    // Debounce timer
    this.debounceTimer = null;
    this.debounceDelay = 1500; // 1.5 seconds

    this.bindEvents();
  }

  generateSessionId() {
    let sid = sessionStorage.getItem('rm_session_id');
    if (!sid) {
      sid = 'ses_' + Date.now().toString(36) + '_' + Math.random().toString(36).substr(2, 9);
      sessionStorage.setItem('rm_session_id', sid);
    }
    return sid;
  }

  getKlaviyoId() {
    const name = "__kla_id=";
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');
    for(let i = 0; i < ca.length; i++) {
      let c = ca[i].trim();
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return null;
  }

  getCartToken() {
    return window.RM_CART_TOKEN || null;
  }

  calculateMaxStep() {
    const s = this.customizer ? this.customizer.state : {};
    let step = 1; // Step 1: Color
    if (s.design) step = Math.max(step, 2);
    if (s.shape) step = Math.max(step, 3);
    if (s.size) step = Math.max(step, 4);
    if ((s.upload_file && s.upload_file.length > 0)) step = Math.max(step, 5);
    if (s.ringsize) step = Math.max(step, 6);
    if (s.side_engravings === 'Yes!' || s.inscription_type === 'Inscribed') step = Math.max(step, 7);
    if (this.converted) step = 8;
    
    this.maxStepReached = Math.max(this.maxStepReached, step);
    return this.maxStepReached;
  }

  compilePayload() {
    const state = this.customizer ? this.customizer.state : {};
    
    const extractFileMetadata = (files) => {
      if (!files) return [];
      return files.map(f => typeof f === 'string' ? f : f.name);
    };

    const configTimeSec = Math.round((Date.now() - this.sessionStartTime) / 1000);

    const payloadState = {
      rm_session_id: this.sessionId,
      cart_token: this.getCartToken(),
      kla_id: this.getKlaviyoId(),
      product: RingmakerLogger.productHandle(),
      
      color: state.color,
      // Silver & gold designer (2026-09-29, §10U A): the metal lives in `material`, not `color`.
      material: state.material,
      overall_hand_engraving: state.overall_hand_engraving,
      overall_hand_engraving_pattern: state.overall_hand_engraving_pattern,
      design: state.design,
      shape: state.shape,
      size: state.size,
      ringsize: state.ringsize,
      
      side_engravings: state.side_engravings,
      left_shoulder_type: state.left_shoulder_type,
      left_shoulder_value: state.left_shoulder_value,
      right_shoulder_type: state.right_shoulder_type,
      right_shoulder_value: state.right_shoulder_value,
      
      inscription_type: state.inscription_type,
      inscription: state.inscription,
      
      upload_files: extractFileMetadata(state.upload_file),
      left_shoulder_files: extractFileMetadata(state.left_shoulder_file),
      right_shoulder_files: extractFileMetadata(state.right_shoulder_file),

      // Telemetry enhancements
      config_time_sec: configTimeSec,
      max_step_reached: this.calculateMaxStep(),
      converted: this.converted,
      upload_retries: state.upload_retries || 0,
      added_to_cart: this.addedToCart,
      atc_attempts: this.atcAttempts,
      atc_result: this.atcResult
    };

    return {
      state: payloadState,
      timestamp: Date.now()
    };
  }

  logState() {
    const payload = this.compilePayload();
    const blob = new Blob([JSON.stringify(payload)], { type: 'application/json' });
    
    navigator.sendBeacon(this.logEndpoint, blob);
    console.log('[RingmakerLogger] Log dispatched via sendBeacon', payload);
  }

  // Named events (Add to Cart results, cart and checkout actions) go to /apps/ringmaker-logs/events, one per call.
  // Each carries its own id, so a beacon the browser sends twice is stored once (the server ignores a known id).
  track(name, data) {
    if (name === 'atc_success') this.addedToCart = true;
    if (name === 'atc_success' || name === 'atc_blocked' || name === 'atc_failed') {
      const d = data || {};
      this.atcResult = name === 'atc_success' ? 'added' : String(name.slice(4) + ':' + (d.step || d.reason || '')).slice(0, 80);
    }
    RingmakerLogger.track(name, data);
    if (name.indexOf('atc_') === 0) this.logState();
  }

  static sessionId() {
    try {
      let sid = sessionStorage.getItem('rm_session_id');
      if (!sid) {
        sid = 'ses_' + Date.now().toString(36) + '_' + Math.random().toString(36).substr(2, 9);
        sessionStorage.setItem('rm_session_id', sid);
      }
      return sid;
    } catch (e) {
      return null;
    }
  }

  static productHandle() {
    const m = (window.location.pathname || '').match(/\/products\/([^/?#]+)/);
    if (!m) return null;
    try { return decodeURIComponent(m[1]).slice(0, 120); } catch (e) { return m[1].slice(0, 120); }
  }

  static track(name, data) {
    try {
      const sid = RingmakerLogger.sessionId();
      if (!sid || !/^[a-z][a-z0-9_]{1,39}$/.test(name)) return false;
      RingmakerLogger.seq = (RingmakerLogger.seq || 0) + 1;
      const event = {
        id: sid.replace(/[^A-Za-z0-9_-]/g, '').slice(-24) + '-' + Date.now().toString(36) + '-' + RingmakerLogger.seq + '-' + Math.random().toString(36).slice(2, 8),
        name: name,
        ts: Date.now(),
        page: (window.location.pathname || '').slice(0, 200),
        data: data || {}
      };
      const body = JSON.stringify({ rm_session_id: sid, events: [event] });
      const url = '/apps/ringmaker-logs/events';
      if (navigator.sendBeacon && navigator.sendBeacon(url, new Blob([body], { type: 'application/json' }))) return true;
      fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: body, keepalive: true }).catch(() => {});
      return true;
    } catch (e) {
      return false;
    }
  }

  triggerLog() {
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }
    this.debounceTimer = setTimeout(() => {
      this.logState();
    }, this.debounceDelay);
  }

  bindEvents() {
    // Immediate log on visibility change
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'hidden') {
        this.logState();
      }
    });

    // Track Add to Cart conversions
    document.addEventListener('click', (e) => {
      const atcBtn = e.target.closest('#rm-add-to-cart, .rm-shop-pay-btn, [data-action="add-to-cart"]');
      if (atcBtn) {
        this.converted = true;
        this.atcAttempts += 1;
        this.calculateMaxStep();
        this.logState();
      }
    });
  }
}
}

document.addEventListener('DOMContentLoaded', () => {
  // Hooked dynamically inside customizer
});
